import { useQuery } from '@tanstack/react-query';
import { getAllModules } from '../services/moduleAccess';

export const useGetAllModules = () => {
	return useQuery({
		queryKey: ['moduleAccess'],
		queryFn: () => getAllModules(),
		staleTime: 1000 * 60 * 5,
	});
};
